import React from "react";
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-media" aria-hidden="true" />
      <div className="hero-content">
        <p className="eyebrow">Fairview Container Management</p>
        <h1>Container unloading crews for busy Ontario warehouses.</h1>
        <p>Fairview CM supports importers, 3PLs, and distribution teams with container destuffing, lumper crews, palletizing, wrapping, staging, and dock-ready freight handling.</p>
        <div className="hero-actions">
          <Link className="primary-button" to="/quote">Request a Quote</Link>
          <Link className="secondary-button" to="/services">View Services</Link>
        </div>
      </div>
      <div className="hero-stats" aria-label="Service highlights">
        <span><strong>20 ft / 40 ft</strong> Containers</span>
        <span><strong>GTA</strong> Service area</span>
        <span><strong>On-demand</strong> Crews</span>
      </div>
    </section>
  );
}
